// import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
// export class StateService {

//   constructor() {
   
//   }

//   public isRenewOfferShown:boolean;
// }


import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StateService {

  constructor() { }

  public AdminListVm: any;
  public RatesListVm: any;
  public BusinessTypeListVm: any;
  public VehicleTypeListVm: any;
  public VehicleMakeListVm: any;
  public AccountListVm: any;
  public TransactionListVm: any;
  public FittingListVm: any;
  public BillingPeriodListVm: any;
  public DeviceListVm: any;
  public VehicleListVm: any;
  public isRenewOfferShown:boolean;

}
